export const ALL_SYMBOLS = [
  "NSE:RELIANCE-EQ",
  "NSE:TCS-EQ",
  "NSE:HDFCBANK-EQ",
  "NSE:INFY-EQ",
  "NSE:ICICIBANK-EQ",
  "NSE:LT-EQ",
  "NSE:SBIN-EQ",
  "NSE:BHARTIARTL-EQ",
  "NSE:ITC-EQ",
  "NSE:HINDUNILVR-EQ",
  "NSE:KOTAKBANK-EQ",
  "NSE:AXISBANK-EQ",
  "NSE:BAJFINANCE-EQ",
  "NSE:ASIANPAINT-EQ",
  "NSE:MARUTI-EQ",
  "NSE:SUNPHARMA-EQ",
  "NSE:TITAN-EQ",
  "NSE:ULTRACEMCO-EQ",
  "NSE:ONGC-EQ",
  "NSE:NTPC-EQ",
  "NSE:POWERGRID-EQ",
  "NSE:TATAMOTORS-EQ",
  "NSE:JSWSTEEL-EQ",
  "NSE:WIPRO-EQ",
  "NSE:TECHM-EQ",
  "NSE:HCLTECH-EQ",
  "NSE:LTIM-EQ",
  "NSE:BAJAJFINSV-EQ",
  "NSE:ADANIENT-EQ",
  "NSE:ADANIPORTS-EQ",
  "NSE:ADANIGREEN-EQ",
  "NSE:ADANIPOWER-EQ",
  "NSE:COALINDIA-EQ",
  "NSE:TATASTEEL-EQ",
  "NSE:GRASIM-EQ",
  "NSE:BPCL-EQ",
  "NSE:HDFCLIFE-EQ",
  "NSE:SBILIFE-EQ",
  "NSE:DRREDDY-EQ",
  "NSE:DIVISLAB-EQ",
  "NSE:EICHERMOT-EQ",
  "NSE:APOLLOHOSP-EQ",
  "NSE:BRITANNIA-EQ",
  "NSE:NESTLEIND-EQ",
  "NSE:SHREECEM-EQ",
  "NSE:CIPLA-EQ",
  "NSE:UPL-EQ",
  "NSE:INDUSINDBK-EQ",
  "NSE:DMART-EQ",
  "NSE:PIDILITIND-EQ",
  "NSE:GODREJCP-EQ",
  "NSE:DABUR-EQ",
  "NSE:COLPAL-EQ",
  "NSE:BANDHANBNK-EQ",
  "NSE:IDFCFIRSTB-EQ",
  "NSE:PNB-EQ",
  "NSE:CANBK-EQ",
  "NSE:TORNTPHARM-EQ",
  "NSE:LUPIN-EQ",
  "NSE:ALKEM-EQ",
  "NSE:AUROPHARMA-EQ",
  "NSE:BIOCON-EQ",
  "NSE:ZOMATO-EQ",
  "NSE:PAYTM-EQ",
  "NSE:NYKAA-EQ",
  "NSE:IRCTC-EQ",
  "NSE:HAL-EQ",
  "NSE:DLF-EQ",
  "NSE:INDIGO-EQ",
  "NSE:LODHA-EQ",
  "NSE:SIEMENS-EQ",
  "NSE:ABB-EQ",
  "NSE:BERGEPAINT-EQ",
  "NSE:SRF-EQ",
  "NSE:AMBUJACEM-EQ",
  "NSE:ACC-EQ",
  "NSE:SAIL-EQ",
  "NSE:JINDALSTEL-EQ",
  "NSE:NMDC-EQ",
  "NSE:HAVELLS-EQ",
  "NSE:VOLTAS-EQ",
  "NSE:TATACONSUM-EQ",
  "NSE:MUTHOOTFIN-EQ",
  "NSE:PAGEIND-EQ",
  "NSE:POLYCAB-EQ",
  "NSE:ASHOKLEY-EQ",
  "NSE:TVSMOTOR-EQ",
  "NSE:BAJAJ-AUTO-EQ",
  "NSE:BOSCHLTD-EQ",
  "NSE:MRF-EQ",
  "NSE:HEROMOTOCO-EQ",
  "NSE:PETRONET-EQ",
  "NSE:GAIL-EQ",
  "NSE:IGL-EQ",
  "NSE:RECLTD-EQ",
  "NSE:PFC-EQ",
  "NSE:UBL-EQ",
  "NSE:MPHASIS-EQ",
  "NSE:COFORGE-EQ",
  "NSE:INDIAMART-EQ",
  "NSE:TATACHEM-EQ",
  "NSE:CHAMBLFERT-EQ",
  "NSE:RAMCOCEM-EQ",
  "NSE:OBEROIRLTY-EQ",
  "NSE:GLAND-EQ",
  "NSE:ABBOTINDIA-EQ",
  "NSE:CONCOR-EQ",
  "NSE:SONACOMS-EQ",
  "NSE:LICI-EQ",
  "NSE:MCX-EQ",
  "NSE:KALYANKJIL-EQ",
  "NSE:NAUKRI-EQ",
  "NSE:STAR-EQ",
  "NSE:PHOENIXLTD-EQ",
  "NSE:ATGL-EQ",
  "NSE:ADANITRANS-EQ",
  "NSE:PRESTIGE-EQ",
  "NSE:BHARATFORG-EQ",
  "NSE:ESCORTS-EQ",
  "NSE:JSWENERGY-EQ",
  "NSE:NHPC-EQ",
  "NSE:OFSS-EQ",
  "NSE:DELTACORP-EQ",
  "NSE:MANAPPURAM-EQ",
  "NSE:FEDERALBNK-EQ",
  "NSE:ICICIPRULI-EQ",
  "NSE:TATAELXSI-EQ",
  "NSE:KANSAINER-EQ",
  "NSE:TRIDENT-EQ",
  "NSE:BSOFT-EQ",
  "NSE:UJJIVANSFB-EQ",
  "NSE:CROMPTON-EQ",
  "NSE:AARTIIND-EQ",
  "NSE:INDHOTEL-EQ",
  "NSE:SPARC-EQ",
  "NSE:AFFLE-EQ",
  "NSE:VGUARD-EQ",
  "NSE:KEI-EQ",
  "NSE:IRB-EQ",
  "NSE:SUZLON-EQ",
];

export const SECTOR_TO_SYMBOLS = {
  "NIFTY IT": [
    "NSE:TCS-EQ",
    "NSE:INFY-EQ",
    "NSE:WIPRO-EQ",
    "NSE:HCLTECH-EQ",
    "NSE:TECHM-EQ",
    "NSE:LTIM-EQ",
    "NSE:MPHASIS-EQ",
    "NSE:COFORGE-EQ",
    "NSE:OFSS-EQ",
    "NSE:BSOFT-EQ",
    "NSE:TATAELXSI-EQ",
  ],

  "NIFTY FMCG": [
    "NSE:ITC-EQ",
    "NSE:HINDUNILVR-EQ",
    "NSE:NESTLEIND-EQ",
    "NSE:BRITANNIA-EQ",
    "NSE:DABUR-EQ",
    "NSE:GODREJCP-EQ",
    "NSE:TATACONSUM-EQ",
    "NSE:COLPAL-EQ",
    "NSE:UBL-EQ",
  ],

  "NIFTY AUTO": [
    "NSE:MARUTI-EQ",
    "NSE:TATAMOTORS-EQ",
    "NSE:EICHERMOT-EQ",
    "NSE:BAJAJ-AUTO-EQ",
    "NSE:HEROMOTOCO-EQ",
    "NSE:TVSMOTOR-EQ",
    "NSE:ASHOKLEY-EQ",
    "NSE:BOSCHLTD-EQ",
    "NSE:MRF-EQ",
    "NSE:SONACOMS-EQ",
  ],

  "NIFTY PHARMA": [
    "NSE:SUNPHARMA-EQ",
    "NSE:DRREDDY-EQ",
    "NSE:DIVISLAB-EQ",
    "NSE:CIPLA-EQ",
    "NSE:LUPIN-EQ",
    "NSE:TORNTPHARM-EQ",
    "NSE:ALKEM-EQ",
    "NSE:AUROPHARMA-EQ",
    "NSE:BIOCON-EQ",
    "NSE:GLAND-EQ",
    "NSE:ABBOTINDIA-EQ",
  ],

  "NIFTY METAL": [
    "NSE:TATASTEEL-EQ",
    "NSE:JSWSTEEL-EQ",
    "NSE:SAIL-EQ",
    "NSE:JINDALSTEL-EQ",
    "NSE:HINDALCO-EQ",
    "NSE:NMDC-EQ",
  ],

  "NIFTY PSU BANK": [
    "NSE:SBIN-EQ",
    "NSE:PNB-EQ",
    "NSE:CANBK-EQ",
    "NSE:BANKBARODA-EQ",
    "NSE:INDIANB-EQ",
  ],

  "NIFTY PRIVATE BANK": [
    "NSE:HDFCBANK-EQ",
    "NSE:ICICIBANK-EQ",
    "NSE:KOTAKBANK-EQ",
    "NSE:AXISBANK-EQ",
    "NSE:INDUSINDBK-EQ",
    "NSE:FEDERALBNK-EQ",
    "NSE:IDFCFIRSTB-EQ",
    "NSE:BANDHANBNK-EQ",
  ],

  "NIFTY OIL & GAS": [
    "NSE:RELIANCE-EQ",
    "NSE:ONGC-EQ",
    "NSE:BPCL-EQ",
    "NSE:GAIL-EQ",
    "NSE:PETRONET-EQ",
    "NSE:IGL-EQ",
    "NSE:ADANIGREEN-EQ",
    "NSE:ADANIPOWER-EQ",
  ],

  "NIFTY REALTY": [
    "NSE:DLF-EQ",
    "NSE:OBEROIRLTY-EQ",
    "NSE:PRESTIGE-EQ",
    "NSE:LODHA-EQ",
    "NSE:PHOENIXLTD-EQ",
  ],

  "NIFTY FINANCIAL SERVICES": [
    "NSE:BAJFINANCE-EQ",
    "NSE:BAJAJFINSV-EQ",
    "NSE:MUTHOOTFIN-EQ",
    "NSE:MANAPPURAM-EQ",
    "NSE:HDFCLIFE-EQ",
    "NSE:SBILIFE-EQ",
    "NSE:ICICIPRULI-EQ",
    "NSE:LICI-EQ",
    "NSE:PAYTM-EQ",
  ],

  "NIFTY INFRASTRUCTURE": [
    "NSE:LT-EQ",
    "NSE:IRB-EQ",
    "NSE:POWERGRID-EQ",
    "NSE:NTPC-EQ",
    "NSE:RECLTD-EQ",
    "NSE:PFC-EQ",
    "NSE:JSWENERGY-EQ",
  ],

  "NIFTY CONSUMER INTERNET": [
    "NSE:ZOMATO-EQ",
    "NSE:NYKAA-EQ",
    "NSE:INDIAMART-EQ",
  ],

  "NIFTY LOGISTICS & TRAVEL": [
    "NSE:ADANIPORTS-EQ",
    "NSE:CONCOR-EQ",
    "NSE:IRCTC-EQ",
    "NSE:INDIGO-EQ",
    "NSE:INDHOTEL-EQ",
  ],

  "NIFTY DEFENCE": ["NSE:HAL-EQ"],
};

// ================================
// AUTO GENERATOR
// ================================
export const SYMBOL_TO_SECTOR = (() => {
  const map = {};

  // fill from sector lists
  for (const [sector, syms] of Object.entries(SECTOR_TO_SYMBOLS)) {
    for (const s of syms) {
      map[s] = sector;
    }
  }

  // fallback for missing
  for (const s of ALL_SYMBOLS) {
    if (!map[s]) {
      map[s] = "OTHER";
    }
  }

  return map;
})();

// ================================
// SECTOR DROPDOWN LIST
// ================================
export const NSE_SECTOR_LIST = [
  "ALL",
  ...Object.keys(SECTOR_TO_SYMBOLS),
  "OTHER",
];
